import { AnalysisContext } from "../context/AnalysisContext";
import { useContext } from "react";

export const useAnalysisContext = () => {
    const context = useContext(AnalysisContext);

    if (!context) {
        return Error('useAnalysisContext must be used inside an AnalysisContextProvider');
    };

    return context;
};